import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SchedulingStaffItem } from "@/actions/ssr/scheduling/getSchedulingStaffSSR";

interface SchedulingStaffState {
  items: SchedulingStaffItem[];
}

const initialState: SchedulingStaffState = {
  items: [],
};

const schedulingStaffSlice = createSlice({
  name: "schedulingStaff",
  initialState,
  reducers: {
    setSchedulingStaff(state, action: PayloadAction<SchedulingStaffItem[]>) {
      state.items = action.payload;
    },
  },
});

export const { setSchedulingStaff } = schedulingStaffSlice.actions;
export default schedulingStaffSlice.reducer;
